<template>
    <div class='page'>
        <el-form
            v-if='isSearch'
            :model='queryForm'
            ref='searchForm'
            label-width='80px'
            :inline='true'
            size='small'
            class='query-form'
            @submit.native.prevent
        >
            <el-form-item label='视频标题' prop='videoTitle'>
                <el-input
                    v-model='queryForm.videoTitle'
                    style='width: 177px'
                    placeholder='请输入视频标题'
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type='primary' icon='el-icon-search' size='small' @click='handleSearch'>查询</el-button>
                <el-button icon='el-icon-refresh' size='small' @click='handleReset'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button type='primary' size='small' @click='handleUpload'>上传</el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        :disabled='multipleSelection.length === 0'
                        @click='handleBatchDelete'
                    >批量删除</el-button>
                </div>
                <div class='icon-group'>
                    <span class='icon-box' title='搜索' @click='toggleSearch'>
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span>
                    <span class='icon-box' title='刷新' @click='refreshList'>
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-table
                ref='businessSchoolTable'
                max-height='100%'
                :data='tableData.list'
                row-key='id'
                border
                v-loading='tableLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size='small'
                @selection-change='handleSelectionChange'
            >
                <el-table-column type='selection' width='70' align='center'></el-table-column>
                <el-table-column align='center' prop='videoTitle' label='视频标题' min-width='140' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='productVideo' label='视频' width='100'>
                    <template slot-scope='scope'>
                        <div
                            v-if='scope.row.productVideo'
                            class='table-video-thumb'
                            @click='handlePreviewTableVideo(scope.row)'
                        >
                            <img
                                v-if='scope.row.productPic'
                                :src='scope.row.productPic'
                                class='table-video-thumb-img'
                                alt='视频封面'
                            />
                            <div v-else class='table-video-thumb-placeholder'>
                                <i class='el-icon-video-camera'></i>
                            </div>
                            <div class='table-video-thumb-mask'>
                                <i class='el-icon-video-play'></i>
                            </div>
                        </div>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' prop='videoDesc' label='视频简介' min-width='160' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='isShow' label='是否显示' width='100'>
                    <template slot-scope='scope'>
                        <el-switch
                            v-model='scope.row.isShow'
                            :active-value='1'
                            :inactive-value='0'
                            active-color='#13ce66'
                            @change='handleIsShowChange(scope.row)'
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column align='center' prop='createTime' label='创建时间' min-width='160'></el-table-column>
                <el-table-column align='center' label='操作' width='100' fixed='right'>
                    <template slot-scope='scope'>
                        <el-button type='text' size='small' style='color: #f56c6c;' @click='handleDelete(scope.row)'>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { queryForm.pageSize = size; getTableData(); }'
                    @current-change='(page) => { queryForm.pageNum = page; getTableData(); }'
                    :current-page='queryForm.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='queryForm.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    background
                    :total='tableData.total'>
                </el-pagination>
            </div>
        </div>
        <el-dialog
            :visible.sync='dialogVisible'
            title='上传视频'
            width='30vw'
            :before-close='handleCloseDialog'
        >
            <div class='detail-dialog-content'>
                <el-form
                    ref='uploadForm'
                    :model='dialogData'
                    :rules='dialogRules'
                    label-width='100px'
                    size='small'
                    style='width: 80%;'
                >
                    <el-form-item label='标题' prop='videoTitle'>
                        <el-input
                            v-model='dialogData.videoTitle'
                            placeholder='请输入标题'
                            clearable
                        ></el-input>
                    </el-form-item>
                    <el-form-item label='二级标题' prop='videoDesc'>
                        <el-input
                            v-model='dialogData.videoDesc'
                            placeholder='请输入二级标题'
                            clearable
                        ></el-input>
                    </el-form-item>
                    <el-form-item label='视频' prop='productVideo'>
                        <div v-if='!dialogData.productVideo' class='upload-video-wrap' v-loading='videoUploading' element-loading-text='视频上传中...'>
                            <el-upload
                                class='upload-video'
                                action=''
                                :show-file-list='false'
                                :before-upload='handleBeforeUpload'
                                :http-request='uploadVideo'
                                accept='.mp4,video/mp4'
                            >
                                <div class='upload-video-trigger'>
                                    <i class='el-icon-video-camera upload-video-icon'></i>
                                    <p class='upload-video-text'>将视频拖到此处，或<em>点击上传</em></p>
                                    <p class='upload-video-tip'>支持 mp4 格式，文件大小不超过 100MB</p>
                                </div>
                            </el-upload>
                        </div>
                        <div v-else class='video-preview'>
                            <div class='video-preview-cover' @click='previewUploadedVideo'>
                                <img
                                    v-if='dialogData.productPic'
                                    :src='dialogData.productPic'
                                    class='cover-image'
                                    alt='视频封面'
                                />
                                <div v-else class='cover-placeholder'>
                                    <i class='el-icon-video-camera'></i>
                                </div>
                                <div class='cover-play-mask'>
                                    <i class='el-icon-video-play'></i>
                                </div>
                            </div>
                            <div class='video-preview-info'>
                                <p class='video-name' :title='uploadMeta.name'>{{ uploadMeta.name }}</p>
                                <p class='video-meta'>
                                    <span v-if='uploadMeta.videoDuration'>时长：{{ formatDuration(uploadMeta.videoDuration) }}</span>
                                    <span v-if='uploadMeta.videoSize'>大小：{{ formatFileSize(uploadMeta.videoSize) }}</span>
                                </p>
                                <div class='video-preview-actions'>
                                    <el-button type='text' size='small' @click='previewUploadedVideo'>预览</el-button>
                                    <el-button type='text' size='small' style='color: #f56c6c;' @click='clearUploadedVideo'>删除</el-button>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' :loading='videoUploading' @click='handleConfirmDialog'>确定</el-button>
                <el-button @click='handleCloseDialog'>取消</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync='videoPreviewVisible'
            title='视频预览'
            width='640px'
            append-to-body
            @close='handleCloseVideoPreview'
        >
            <video
                v-if='previewVideoUrl'
                :key='previewVideoUrl'
                :src='previewVideoUrl'
                controls
                autoplay
                class='preview-video-player'
            ></video>
        </el-dialog>
    </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { post, get, upload, deleteFun } from '@/utils/request.js';
import { UPLOAD_PATH_VIDEO } from '@/utils/constant.js';

export default {
    name: 'BusinessSchool',
    components: {
        Refresh,
        Search
    },
    data() {
        return {
            isSearch: false,
            queryForm: {
                pageNum: 1,
                pageSize: 10,
                videoTitle: ''
            },
            tableData: {
                list: [],
                total: 0
            },
            tableLoading: false,
            multipleSelection: [],
            dialogVisible: false,
            dialogData: {
                videoTitle: '',
                videoDesc: '',
                productVideo: '',
                productPic: ''
            },
            dialogRules: {
                videoTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                productVideo: [{ required: true, message: '请上传视频', trigger: 'change' }]
            },
            uploadMeta: {
                name: '',
                videoDuration: 0,
                videoSize: 0
            },
            videoUploading: false,
            videoPreviewVisible: false,
            previewVideoUrl: '',
            fileType: ['mp4'],
            fileSize: 100
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        toggleSearch() {
            this.isSearch = !this.isSearch;
        },
        getTableData() {
            this.tableLoading = true;
            get('/shop/businessschoolvideo/findList', { ...this.queryForm }).then((res) => {
                if (res.success) {
                    if (res.page) {
                        this.tableData.list = res.page.list;
                        this.tableData.total = res.page.total;
                    } else if (res.pageInfo) {
                        this.tableData.list = res.pageInfo.list;
                        this.tableData.total = res.pageInfo.total;
                    } else {
                        this.tableData.list = res.list || [];
                        this.tableData.total = this.tableData.list.length;
                    }
                } else {
                    this.$message.error(res.msg);
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        handleSearch() {
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        handleReset() {
            this.queryForm.videoTitle = '';
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        refreshList() {
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        getDefaultDialogData() {
            return {
                videoTitle: '',
                videoDesc: '',
                productVideo: '',
                productPic: ''
            };
        },
        resetDialogData() {
            this.dialogData = this.getDefaultDialogData();
            this.uploadMeta = {
                name: '',
                videoDuration: 0,
                videoSize: 0
            };
            this.videoUploading = false;
            this.videoPreviewVisible = false;
            this.previewVideoUrl = '';
            this.$nextTick(() => {
                if (this.$refs.uploadForm) {
                    this.$refs.uploadForm.resetFields();
                    this.$refs.uploadForm.clearValidate();
                }
            });
        },
        handleUpload() {
            this.dialogData = this.getDefaultDialogData();
            this.uploadMeta = {
                name: '',
                videoDuration: 0,
                videoSize: 0
            };
            this.videoUploading = false;
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.uploadForm) {
                    this.$refs.uploadForm.clearValidate();
                }
            });
        },
        handleCloseDialog() {
            this.dialogVisible = false;
            this.resetDialogData();
        },
        uploadVideo(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            this.videoUploading = true;
            upload(UPLOAD_PATH_VIDEO, formData).then((res) => {
                if (res.success) {
                    this.dialogData.productVideo = res.url;
                    this.dialogData.productPic = res.videoCover || '';
                    this.uploadMeta = {
                        name: file.name,
                        videoDuration: res.videoDuration || 0,
                        videoSize: res.videoSize || 0
                    };
                    this.$nextTick(() => {
                        this.$refs.uploadForm && this.$refs.uploadForm.validateField('productVideo');
                    });
                } else {
                    this.$message.error(res.msg);
                }
            }).finally(() => {
                this.videoUploading = false;
            });
        },
        formatDuration(duration) {
            if (!duration) {
                return '--';
            }
            const minutes = Math.floor(duration / 60);
            const seconds = duration % 60;
            return minutes > 0 ? `${minutes}分${seconds}秒` : `${seconds}秒`;
        },
        formatFileSize(size) {
            if (!size) {
                return '--';
            }
            if (size < 1024) {
                return `${size} B`;
            }
            if (size < 1024 * 1024) {
                return `${(size / 1024).toFixed(2)} KB`;
            }
            return `${(size / 1024 / 1024).toFixed(2)} MB`;
        },
        previewUploadedVideo() {
            if (!this.dialogData.productVideo) {
                return;
            }
            this.previewVideoUrl = this.dialogData.productVideo;
            this.videoPreviewVisible = true;
        },
        handlePreviewTableVideo(row) {
            if (!row.productVideo) {
                return;
            }
            this.previewVideoUrl = row.productVideo;
            this.videoPreviewVisible = true;
        },
        handleCloseVideoPreview() {
            this.videoPreviewVisible = false;
            this.previewVideoUrl = '';
        },
        clearUploadedVideo() {
            this.dialogData.productVideo = '';
            this.dialogData.productPic = '';
            this.uploadMeta = {
                name: '',
                videoDuration: 0,
                videoSize: 0
            };
        },
        handleBeforeUpload(file) {
            if (this.dialogData.productVideo) {
                this.$message.info('最多上传一个视频');
                return false;
            }
            if (this.fileType && file) {
                let fileExtension = '';
                if (file.name.lastIndexOf('.') > -1) {
                    fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
                }
                const isTypeOk = this.fileType.some((type) => {
                    if (file.type.indexOf(type) > -1) return true;
                    if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                    return false;
                });
                if (!isTypeOk) {
                    this.$message.error(`文件格式不正确，请上传 ${this.fileType.join('/')} 格式文件`);
                    return false;
                }
            }
            if (this.fileSize && file) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                    this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB`);
                    return false;
                }
            }
            return true;
        },
        handleConfirmDialog() {
            if (this.videoUploading) {
                return;
            }
            this.$refs.uploadForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                const { videoTitle, videoDesc, productVideo, productPic } = this.dialogData;
                post('/shop/businessschoolvideo/add', {
                    videoTitle,
                    videoDesc,
                    productVideo,
                    productPic
                }).then((res) => {
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.handleCloseDialog();
                        this.getTableData();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            });
        },
        handleIsShowChange(row) {
            post('/shop/businessschoolvideo/edit', {
                id: row.id,
                isShow: row.isShow
            }).then((res) => {
                if (res.success) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                    this.getTableData();
                }
            }).catch(() => {
                this.getTableData();
            });
        },
        handleDelete(row) {
            this.confirmAndDelete(row.id);
        },
        handleBatchDelete() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning('请选择要删除的数据');
                return;
            }
            const ids = this.multipleSelection.map((item) => item.id).join(',');
            this.confirmAndDelete(ids);
        },
        handleSelectionChange(selection) {
            this.multipleSelection = selection;
        },
        confirmAndDelete(ids) {
            this.$confirm('确定删除所选视频吗？', '提示', {
                type: 'warning'
            }).then(() => {
                deleteFun('/shop/businessschoolvideo/delete', { ids }).then((res) => {
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.multipleSelection = [];
                        if (this.$refs.businessSchoolTable) {
                            this.$refs.businessSchoolTable.clearSelection();
                        }
                        this.getTableData();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }).catch(() => {});
        }
    }
};
</script>

<style scoped lang="scss">
.upload-video-wrap {
    width: 100%;
}

.upload-video {
    width: 100%;

    ::v-deep .el-upload.el-upload--text {
        display: block;
        width: 100%;
        height: auto;
        border: none;
        border-radius: 0;
        background: transparent;
        overflow: visible;
        text-align: left;
        cursor: default;
    }
}

.upload-video-trigger {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 148px;
    padding: 16px;
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafcff;
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s;

    &:hover {
        border-color: #409eff;
        background: #f5f9ff;
    }
}

.upload-video-icon {
    margin-bottom: 10px;
    color: #409eff;
    font-size: 36px;
    line-height: 1;
}

.upload-video-text {
    margin: 0;
    color: #606266;
    font-size: 14px;
    line-height: 22px;

    em {
        color: #409eff;
        font-style: normal;
    }
}

.upload-video-tip {
    margin: 8px 0 0;
    color: #909399;
    font-size: 12px;
    line-height: 18px;
}

.video-preview {
    display: flex;
    align-items: center;
    padding: 12px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: #fafafa;
}

.video-preview-cover {
    position: relative;
    flex-shrink: 0;
    width: 120px;
    height: 68px;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    background: #000;
}

.cover-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.cover-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 28px;
}

.cover-play-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 28px;
    background: rgba(0, 0, 0, 0.35);
    opacity: 0;
    transition: opacity 0.2s;
}

.video-preview-cover:hover .cover-play-mask {
    opacity: 1;
}

.video-preview-info {
    flex: 1;
    min-width: 0;
    margin-left: 12px;
}

.video-name {
    margin: 0 0 6px;
    overflow: hidden;
    color: #303133;
    font-size: 14px;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.video-meta {
    margin: 0 0 4px;
    color: #909399;
    font-size: 12px;
    line-height: 18px;

    span + span {
        margin-left: 12px;
    }
}

.video-preview-actions {
    margin-top: 2px;
}

.preview-video-player {
    display: block;
    width: 100%;
    max-height: 360px;
    background: #000;
}

.table-video-thumb {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 50px;
    overflow: hidden;
    border-radius: 4px;
    cursor: pointer;
    background: #000;
}

.table-video-thumb-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.table-video-thumb-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 20px;
}

.table-video-thumb-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    background: rgba(0, 0, 0, 0.35);
    opacity: 0;
    transition: opacity 0.2s;
}

.table-video-thumb:hover .table-video-thumb-mask {
    opacity: 1;
}
</style>
